import fetchApi from '../../../lib/fetchApi.ts';
import { SurveyItem } from '../types/index.ts'

export const getPendigSurveyAPI = async (): Promise<SurveyItem[]> => {
    const response = await fetchApi.get<SurveyItem[]>('/survey/pending');
    return response;
};
